// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vec-select-option-focused {
    outline: 2px solid var(--color-focus-outline);
    outline-offset: -2px;
}

.ant-select-item-option-selected {
    background-color: var(--color-surface-brand-strong) !important;
    color: var(--color-text-on-brand) !important;
}

.ant-select-item-option-selected.vec-select-option-focused {
    outline-color: var(--color-text-on-brand);
    outline-offset: -4px;
}
`, "",{"version":3,"sources":["webpack://./vector/src/Select/Select.module.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA;IACI,8DAA8D;IAC9D,4CAA4C;AAChD;;AAEA;IACI,yCAAyC;IACzC,oBAAoB;AACxB","sourcesContent":[":global(.vec-select-option-focused) {\n    outline: 2px solid var(--color-focus-outline);\n    outline-offset: -2px;\n}\n\n:global(.ant-select-item-option-selected) {\n    background-color: var(--color-surface-brand-strong) !important;\n    color: var(--color-text-on-brand) !important;\n}\n\n:global(.ant-select-item-option-selected.vec-select-option-focused) {\n    outline-color: var(--color-text-on-brand);\n    outline-offset: -4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
